<template>
  <div>
    <div class="top">
      <img class="picimg" src="@/assets/image/数字地形服务.png" />
    </div>
    <div style="display: flex; align-items: center" class="prompt">
      <img class="icon" src="@/assets/images/zhuye.png" />
      <span class="color858"
        >&nbsp;&nbsp;你现在的位置&nbsp;&nbsp;/&nbsp;&nbsp;首页&nbsp;&nbsp;/&nbsp;&nbsp;</span
      >
      <span>数字地形服务</span>
    </div>
    <div class="titleBox">
      <span class="title">DIGITAL TERRAIN</span>
      <span class="title1">数字地形服务</span>
      <span class="line"></span>
    </div>
    <div class="service-main dt-main">
      <section class="dt-section">
        <h2 class="dt-h2">
          <span class="dt-h2-mark"></span>
          应用介绍
        </h2>
        <p class="dt-p">
          数字地形是以无人机航飞，形成数字点云后进行地面坐标和高程信息提取，从而形成数字地形模型，描述地面表面高程信息，并用于地形测绘、土方测算、项目规划等目的。
        </p>
        <p class="dt-p">
          <span class="dt-kw">地形测绘：</span>数字地形可以作为地形信息的重要数据源，广泛应用于地貌分析、地形显示和模拟、地质、水文、生态等领域。
        </p>
        <p class="dt-p">
          <span class="dt-kw">建筑规划：</span>数字地形数据可以为城市规划、交通规划等提供重要的地形数据，用于分析景观、地貌、地形等的空间分布规律和特征，指导发展规划。
        </p>
        <p class="dt-p">
          <span class="dt-kw">工程建设：</span>数字地形数据在工程建设中可用于绘制工程图纸、地形降尺度分析和设计等。例如，数字地形数据可以用于确定坡度和坡度方向，开展竖向设计，计算土方挖填工程量等。
        </p>
      </section>

      <section class="dt-section">
        <h2 class="dt-h2">
          <span class="dt-h2-mark"></span>
          技术框架
        </h2>
        <div class="dt-framework">
          <div class="dt-fw-row">
            <div class="dt-fw-label dt-fw-label--app">应用</div>
            <div class="dt-fw-body">
              <div class="dt-fw-cards">
                <div class="dt-fw-card">
                  <p class="dt-fw-card-title">土方量精算</p>
                  <p class="dt-fw-card-desc">
                    土方开挖量、土方回填量、土方调运量、……
                  </p>
                </div>
                <div class="dt-fw-card">
                  <p class="dt-fw-card-title">土方方案优化</p>
                  <p class="dt-fw-card-desc">
                    开挖标高优化、回填标高优化、调运方案优化、经济比选、……
                  </p>
                </div>
                <div class="dt-fw-card">
                  <p class="dt-fw-card-title">辅助场地设计</p>
                  <p class="dt-fw-card-desc">
                    山体修复、园林景观设计、步道设计、游乐项目规划、……
                  </p>
                </div>
                <div class="dt-fw-card">
                  <p class="dt-fw-card-title">辅助土方施工</p>
                  <p class="dt-fw-card-desc">
                    可视化交底、方案模拟、施工数据采集、土方施工量、数据对比和调整。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="dt-fw-row">
            <div class="dt-fw-label dt-fw-label--tech">技术</div>
            <div class="dt-fw-body dt-fw-body--tags">
              <span class="dt-tag">模型计算</span>
              <span class="dt-tag">三维可视化</span>
              <span class="dt-tag">动态模拟</span>
            </div>
          </div>

          <div class="dt-fw-row">
            <div class="dt-fw-label dt-fw-label--model">模型</div>
            <div class="dt-fw-body dt-fw-body--tags">
              <span class="dt-tag">倾斜摄影模型</span>
              <span class="dt-tag">点云模型</span>
              <span class="dt-tag">地形模型</span>
              <span class="dt-tag">场地模型</span>
            </div>
          </div>

          <div class="dt-fw-row">
            <div class="dt-fw-label dt-fw-label--data">数据</div>
            <div class="dt-fw-body dt-fw-body--tags">
              <span class="dt-tag">无人机</span>
              <span class="dt-tag">激光雷达</span>
              <span class="dt-tag">人工复测</span>
            </div>
          </div>
        </div>
      </section>

      <section class="dt-section">
        <h2 class="dt-h2">
          <span class="dt-h2-mark"></span>
          实施目标
        </h2>
        <div class="dt-goals">
          <p class="dt-goal-line">
            <span class="dt-goal-title">土方量精算：</span>开展高密度的地形测绘，并绘制1:500地形图；随后创建地形模型，并根据设计方案，通过模型计算出土方工程量；
          </p>
          <p class="dt-goal-line">
            <span class="dt-goal-title">土方方案优化：</span>通过对场地方案的调整和优化，来计算出不同设计方案对土方的影响；通过经济对比，抉择出最优的土方方案；考虑项目施工计划，制定最优的土方调运方案；
          </p>
          <p class="dt-goal-line">
            <span class="dt-goal-title">辅助场地设计：</span>使用倾斜摄影模型和场地模型，辅助园林、山体、步道等的方案规划和设计；通过对土方方案的优化，优化场地标高，以及场地的平面设计；
          </p>
          <p class="dt-goal-line">
            <span class="dt-goal-title">辅助土方施工：</span>通过可视化模型和动态模拟，指导现场土方施工；定期采集现场数据，计算施工工程量，复核和调整土方施工方案；
          </p>
        </div>
      </section>

      <section class="dt-section dt-section--cases">
        <h2 class="dt-h2 dt-h2--cases">
          <span class="dt-h2-mark dt-h2-mark--cases"></span>
          应用案例（节选）
        </h2>

        <div class="dt-case-row dt-case-row--text-img">
          <div class="dt-case-text-col">
            <div class="dt-case-tag">倾斜摄影模型：</div>
            <p class="dt-case-body">
              采用无人机搭载高清摄像头，对现场进行航拍，航拍路线及高度应经过专业计算和设计;当航拍工作采集完成后，利用专业软件进行空三计算、修正:待运行结果合格后，重建三维倾斜摄影模型，并输出3D模型，产品格式为OSGB。
            </p>
          </div>
          <div class="dt-case-img-col">
            <img
              class="dt-case-photo"
              src="@/assets/image/倾斜摄影模型.png"
              alt="倾斜摄影三维模型"
            />
          </div>
        </div>

        <div class="dt-case-row dt-case-row--img-text">
          <div class="dt-case-img-col">
            <img
              class="dt-case-photo"
              src="@/assets/image/数字地形.png"
              alt="地面点云模型"
            />
          </div>
          <div class="dt-case-text-col">
            <div class="dt-case-tag dt-case-tag--tail-right">地面点云：</div>
            <p class="dt-case-body">
              将高精度三维激光扫描仪、GNSS卫星定位系统、惯性导航系统、360度全景相机以及控制模块、时间同步模块等高度集成，融合多种定位模式，获取高精度多元数据。在外业工作完成后，通过配套软件进行数据处理与加工，获取4D数据成果以及三维点云模型。
            </p>
          </div>
        </div>

        <div class="dt-case-row dt-case-row--text-img">
          <div class="dt-case-text-col">
            <div class="dt-case-tag">地形模型：</div>
            <p class="dt-case-body">
              根据倾斜摄影模型、点云模型及更新后的地形图创建三维地形模型。交付模型满足如下要求:按高程分层建模，可编辑，通过该模型能够查看原始地形的三维坐标、高程、坡度等内容。辅助高程分析、坡度分析、坡向分析，分析文件能准确反应本项目内的各环境情况，为项目选址和设备落位提供依据。
            </p>
          </div>
          <div class="dt-case-img-col">
            <img
              class="dt-case-photo"
              src="@/assets/image/地形模型.png"
              alt="三维地形模型"
            />
          </div>
        </div>

        <div class="dt-case-row dt-case-row--img-text">
          <div class="dt-case-img-col">
            <img
              class="dt-case-photo"
              src="@/assets/image/道路模拟.png"
              alt="道路施工模拟场景"
            />
          </div>
          <div class="dt-case-text-col">
            <div class="dt-case-tag dt-case-tag--tail-right">道路模拟：</div>
            <p class="dt-case-body">
              通过BIM软件整合倾斜摄影、场地、道路、边坡等模型，形成三维场地还原场景，用作决策、指导、展示等。以及使用基于BIM技术的三维可视化和动画模拟技术，制作出土石方调运演示动画、边坡支护施工模拟、土石方挖填模拟等动画视频，展示出施工工艺及质量控制要点，指导现场的施工交底。
            </p>
          </div>
        </div>
      </section>
    </div>
    <Bottom />
    <Right />
  </div>
</template>

<script>
import Bottom from "./bottom.vue";
import Right from "./right.vue";

export default {
  components: {
    Bottom,
    Right,
  },
};
</script>

<style lang="scss" scoped>
$dt-green: #1b5e3a;
$dt-yellow: #e6c229;
$dt-kw-red: #9b1c1c;
$dt-goal-blue: #5b9bd5;
$dt-fw-bg: #e8eaf6;
$dt-label-app: #8e6bc9;
$dt-label-tech: #e6b422;
$dt-label-model: #e67e33;
$dt-label-data: #3d9b6a;

.service-main.dt-main {
  max-width: 960px;
  margin: 0 auto 80px;
  padding: 0 40px;
  line-height: 1.85;
  font-size: 16px;
  color: #333;
}

.dt-section {
  margin-top: 40px;

  &:first-of-type {
    margin-top: 20px;
  }
}

.dt-h2 {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: $dt-green;
  margin: 0 0 18px;
}

.dt-h2-mark {
  width: 10px;
  height: 10px;
  background: $dt-yellow;
  margin-right: 10px;
  flex-shrink: 0;
}

.dt-p {
  margin: 0 0 14px;
  text-align: justify;
}

.dt-kw {
  color: $dt-kw-red;
  font-weight: 700;
}

.dt-framework {
  background: $dt-fw-bg;
  border: 1px solid rgba(100, 120, 180, 0.25);
  border-radius: 6px;
  padding: 16px;
  box-sizing: border-box;
}

.dt-fw-row {
  display: flex;
  align-items: stretch;
  gap: 0;
  min-height: 56px;

  & + & {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid rgba(100, 120, 180, 0.2);
  }
}

.dt-fw-label {
  width: 44px;
  min-width: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  letter-spacing: 0.15em;
  border-radius: 4px 0 0 4px;
}

.dt-fw-label--app {
  background: $dt-label-app;
}

.dt-fw-label--tech {
  background: $dt-label-tech;
}

.dt-fw-label--model {
  background: $dt-label-model;
}

.dt-fw-label--data {
  background: $dt-label-data;
}

.dt-fw-body {
  flex: 1;
  min-width: 0;
  background: rgba(255, 255, 255, 0.85);
  padding: 12px 14px;
  border-radius: 0 6px 6px 0;
  display: flex;
  align-items: center;
}

.dt-fw-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.dt-fw-card {
  flex: 1 1 calc(25% - 12px);
  min-width: 160px;
  background: #fff;
  border: 1px solid #dde1f0;
  border-radius: 8px;
  padding: 12px 10px;
  box-sizing: border-box;
}

.dt-fw-card-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 700;
  color: #333;
}

.dt-fw-card-desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.65;
  color: #555;
}

.dt-fw-body--tags {
  flex-wrap: wrap;
  gap: 10px;
}

.dt-tag {
  display: inline-block;
  padding: 8px 14px;
  background: #e8ecf2;
  border: 1px solid #cfd6e6;
  border-radius: 4px;
  font-size: 14px;
  color: #444;
}

.dt-goals {
  margin: 0;
}

.dt-goal-line {
  margin: 0 0 16px;
  text-align: justify;
}

.dt-goal-title {
  color: $dt-goal-blue;
  font-weight: 700;
}

$dt-case-orange: #f29600;

.dt-h2--cases {
  color: $dt-goal-blue;
}

.dt-h2-mark--cases {
  background: $dt-yellow;
}

.dt-section--cases {
  margin-top: 48px;
}

.dt-case-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
}

.dt-case-text-col {
  flex: 1 1 38%;
  min-width: 280px;
  max-width: 100%;
}

.dt-case-img-col {
  flex: 1 1 55%;
  min-width: 0;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dt-case-photo {
  display: block;
  width: 100%;
  height: auto;
  max-height: 360px;
  object-fit: contain;
}

.dt-case-tag {
  display: inline-block;
  margin-bottom: 14px;
  padding: 8px 22px 8px 22px;
  background: $dt-case-orange;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.35;
  clip-path: polygon(0 50%, 12px 0, 100% 0, 100% 100%, 12px 100%);
}

.dt-case-tag--tail-right {
  padding: 8px 22px 8px 20px;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%);
}

.dt-case-body {
  margin: 0;
  text-align: justify;
  color: #333;
  line-height: 1.9;
}

@media (max-width: 768px) {
  .service-main.dt-main {
    padding: 0 20px;
  }

  .dt-fw-row {
    flex-direction: column;
  }

  .dt-fw-label {
    width: 100%;
    min-width: 0;
    min-height: 40px;
    writing-mode: horizontal-tb;
    border-radius: 4px 4px 0 0;
  }

  .dt-fw-body {
    border-radius: 0 0 6px 6px;
  }

  .dt-fw-card {
    flex: 1 1 100%;
    min-width: 0;
  }

  .dt-case-row {
    flex-direction: column;
    align-items: stretch;
    gap: 18px;
  }

  .dt-case-img-col {
    order: -1;
    flex: 1 1 auto;
  }

  .dt-case-photo {
    max-height: 280px;
  }
}
</style>
